import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const COLLAPSED_HEIGHT = 'max-h-40'

/** One long field of a run — prompt, response, error, metadata. */
export function RunTextBlock({
  label,
  text,
  tone,
  collapsed = false,
}: {
  label: string
  text: string
  tone?: 'error'
  collapsed?: boolean
}) {
  const [open, setOpen] = useState(!collapsed)
  if (!text) return null

  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h4 className="text-sm font-semibold">{label}</h4>
        <Button variant="ghost" size="sm" onClick={() => setOpen(!open)}>
          {open ? 'Hide' : 'Show'}
        </Button>
      </div>
      {open && (
        <pre
          className={cn(
            'overflow-auto rounded-sm border p-3 font-mono text-xs whitespace-pre-wrap',
            COLLAPSED_HEIGHT,
            tone === 'error' ? 'border-error/35 bg-error/10' : 'border-ink-100 bg-ink-50'
          )}
        >
          {text}
        </pre>
      )}
    </section>
  )
}
